import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useFileReaderArrayBuffer } from "../../../../hooks";
import { ViewerControlButtonDownload, ViewerControlsBox } from "../../controls";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { ViewArchiveInfoLoadingIcon } from "../../status";
import { read, utils } from 'xlsx';
import DataGrid from 'react-data-grid';
import clsx from 'clsx';
import '@isyc-react/design/main';
import "./view-excel.style.scss";
export const ExcelCellFormatter = props => /*#__PURE__*/React.createElement(React.Fragment, null, props.row[props.column.key]);

// TODO implement onViewed callback
// TODO test what happens when there are two columns with same name
// TODO calls to xlsx lib should be in a Web Worker to minimize bundle and do not block main thread in heavy cost readings
export const ViewExcel = props => {
  const {
    file,
    onViewed
  } = props;
  const {
    arrayBuffer
  } = useFileReaderArrayBuffer(file);
  const [loading, setLoading] = React.useState(true);
  const [workbook, setWorkbook] = React.useState(null);
  const [sheetName, setSheetName] = React.useState(null);
  const jsonSheets = React.useRef({});
  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => {
    if (arrayBuffer) {
      const workbook = read(arrayBuffer, {
        type: 'array'
      });

      // console.log('WORKBOOK: ', workbook)

      setWorkbook(workbook);
      const firstSheetName = workbook.SheetNames[0];
      if (firstSheetName) setSheetName(firstSheetName);
      setLoading(false);
    }
  }, [arrayBuffer]);
  React.useEffect(() => {
    if (workbook && sheetName) {
      let jsonSheet = jsonSheets.current[sheetName];
      if (!jsonSheet) {
        jsonSheet = utils.sheet_to_json(workbook.Sheets[sheetName]);
        jsonSheets.current[sheetName] = jsonSheet;
      }

      // console.log('JSON SHEET: ', jsonSheet);

      const firstRow = jsonSheet[0];
      const headerColumns = firstRow ? Object.keys(firstRow).map((item, i) => ({
        key: item,
        name: item === '__EMPTY' ? ' ' : item,
        // frozen: i < frozen, // TODO add possible frozen prop? ...
        resizable: true,
        formatter: ExcelCellFormatter
      })) : [];
      const bodyRows = jsonSheet;
      setColumns(headerColumns);
      setRows(bodyRows);
    }
  }, [workbook, sheetName]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-excel-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-excel-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  }))), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-excel-document"
  }, loading ? /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }) : /*#__PURE__*/React.createElement("div", {
    className: "w-100 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-excel-sheet-names"
  }, workbook && /*#__PURE__*/React.createElement(React.Fragment, null, workbook.SheetNames.map((sName, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: clsx('view-excel-sheet-name', {
      active: sName === sheetName
    }),
    onClick: () => setSheetName(sName)
  }, sName)))), /*#__PURE__*/React.createElement(DataGrid, {
    enableVirtualization: true,
    columns: columns,
    rows: rows,
    rowHeight: 22,
    className: "view-excel-fill-grid rdg-light"
  })))));
};